<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Add Feedback</v-toolbar-title>

		    <!-- <v-spacer></v-spacer> -->

		    <!-- <v-btn round-borders outline @click="fn_checkValidations">save</v-btn> -->
		</v-toolbar>

		<v-form full-height class="form-element hasToolbar hasFooter grey-back">

			<v-layout wrap white-background pb-2>

				<v-flex xs12 sm12 md12 form-item>
					<v-select
						:prepend-icon="feedbackType.value == 1 ? 'sentiment_very_satisfied' : feedbackType.value == 2 ? 'sentiment_very_dissatisfied' : feedbackType.value == 3 ? 'chat_bubble_outline' : 'bug_report' "
			          v-model="feedbackType"
			          placeholder="Type"
			          :items="feedbackTypes"
			          item-text="name"
			          item-value="value"
			          label="Type"
			          return-object
			          single-line>
			        </v-select>	
				</v-flex>
				

				<v-flex xs12 sm12 md12 form-item>
					<div class="light-opacity-color pb-1 font12">
						{{fn_getMessageFieldLable()}}
					</div>
	               <v-textarea  
	               		rows="10" 
	               		outline 
	               		solo
	               		flat
						v-model="Form.FeedbackText" 
						placeholder=" "
						v-validate="'required'"
						data-vv-name="message"
               			:error-messages="errors.collect('message')"
               			required>
					</v-textarea>
	            </v-flex>
								
			</v-layout>
		</v-form>

		<div style="position:fixed;bottom:0" full-width>
			<v-btn noroundborders color="primary" block nomargin class="height48" @click="fn_checkValidations" style="border-radius:0;">Submit</v-btn>
		</div>

	</div>
</template>

<script>

	export default{
		data(){
			return{
				Form:{"Rating":null, "FeedbackType":null, "FeedbackText":null},
				feedbackTypes: [
		          { name: "I like something", value:1 },
		          { name: "I don't like something", value:2 },
		          { name: "I have a suggestion", value:3 },
		          { name: "Report a bug", value:4 },
		        ],
		        feedbackType: { name: "I like something", value:1 },
				loading:false,
				tagId:null,
				draftStorageId:null,
				unwatch: false,
				backButtonPress:false
			}
		},
		methods:{

			fn_getMessageFieldLable: function(){
				if(this.feedbackType.value == 1){
					return "What did you like?";
				}
				else if(this.feedbackType.value == 2){
					return "What did you not like?";
				}
				else if(this.feedbackType.value == 3){
					return "What do you suggest?";
				}
				else{
					return "What is the bug?";
				}
			},

			fn_checkValidations: function(){
			    this.$validator.validateAll().then((result) => {
			        if (result) {
			        	this.showLoading('Please wait...');
			        	let self = this;
			        	this.$root.fn_getAuthToken(function(token){
							self.fn_postFeedback(token);
						})
			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			    });
			},

			fn_postFeedback: function(token){
				if(!navigator.onLine){
					this.showToast('Internet not available');
					this.hideLoading();
					return;
				}

				let self = this;
				let postObj = this.Form;
				postObj.BusinessID = this.$root.CurrentBusiness.BusinessID;
				postObj.token = token;
				postObj.FeedbackType = this.feedbackType.value;

				if(!token){
					console.log("Token not found");
					this.hideLoading();
					this.showToast("Something went wrong. Try again!.");
					return;
				}

				console.log(JSON.stringify(postObj));

		  		this.postServerData('PostUserFeedback', postObj, 
					{
						onSuccess: function(response){
				            // self.fn_resetDatabase(backupAccountId);
				            self.hideLoading();
				            self.showToast('Thanks for the feedback');
				            self.fn_goBack();
				        }, 
				        onError: function(error){
				          	console.log(error);
				          	self.hideLoading();
				          	AndroidRoutingTest.revokeAccount();
				          	if(typeof JSON.parse(error) == 'object'){
					          	let response = JSON.parse(error);
					          	self.showToast(response.Message);
					        }
				        }
					}
		        );
			},

			fn_goBack: function(){
				this.$router.go(-1);
			}
		},
		mounted: function(){
			var self = this;
			window.js_globals.fn_onBackPress = this.fn_goBack;
			this.Form.Rating = Number(this.$route.params.rating);
			

			if(this.Form.Rating <= 3){
				this.feedbackType = { name: "I don't like something", value:2 };
			}
		}
	}

</script>


// WEBPACK FOOTER //
// src/components/settings/feedback/form.vue